import { pdfjs } from "react-pdf"
// @ts-ignore - worker module ships no type declarations
import { WorkerMessageHandler } from "pdfjs-dist/build/pdf.worker.mjs"

// Bypass the Web Worker entirely and force pdf.js to use the "fake worker"
// (parsing on the main thread) unconditionally in both DEV and PROD.
//
// This completely solves:
// 1. Vite dev server breaking the worker handshake.
// 2. CSP (Content Security Policy) errors from cross-origin blob: workers.
// 3. Silent handshake mismatches in PROD (where the worker loads but hangs
//    indefinitely waiting for the "test" message, returning HTTP 206).
//
// By populating `globalThis.pdfjsWorker` with the exact property pdf.js expects,
// pdf.js detects it and immediately sets up the fake worker, skipping the workerSrc read.
;(globalThis as any).pdfjsWorker = { WorkerMessageHandler }

// Stable options for <Document>: point pdf.js to the matching-version asset
// folders so JPEG2000 images (wasm), CJK/CMap and standard fonts decode instead
// of warning. Module-level constant → referentially stable for react-pdf.
const V = pdfjs.version
export const PDF_OPTIONS = {
  wasmUrl: `https://unpkg.com/pdfjs-dist@${V}/wasm/`,
  cMapUrl: `https://unpkg.com/pdfjs-dist@${V}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${V}/standard_fonts/`,
}
